import React, { Component } from "react";
import { View, Text, StyleSheet, Image, TouchableOpacity } from "react-native";
import PropTypes from "prop-types";
import { MaterialIcons } from "@expo/vector-icons";
import colors from "../../constants/colors";
import { BRANDING } from "@env";
import { branding } from "../../api";

class FormCard extends Component {
  renderIqops() {
    const { lastUsed, grouped, isLastInGroup, isSelected } = this.props;
    const formEnabled = this.props.formEnabled !== false;
    const chevronColor = isSelected
      ? colors.primary
      : lastUsed
        ? colors.iqopsLastUsed
        : colors.iqopsFormArrow;

    return (
      <TouchableOpacity
        style={[
          styles.iqopsCard,
          lastUsed && styles.iqopsCardLastUsed,
          grouped && styles.iqopsCardGrouped,
          grouped && isLastInGroup && styles.iqopsCardGroupedLast,
          isSelected && styles.iqopsCardSelected,
          !formEnabled && styles.iqopsCardDisabled,
        ]}
        onPress={this.props.action}
        disabled={!formEnabled}
        activeOpacity={0.75}
        key={this.props.index}
      >
        <Text
          style={[styles.iqopsTitle, lastUsed && styles.iqopsTitleLastUsed]}
          numberOfLines={2}
        >
          {this.props.formTitle}
        </Text>
        <MaterialIcons
          name="chevron-right"
          size={22}
          color={chevronColor}
          style={styles.iqopsChevron}
        />
      </TouchableOpacity>
    );
  }

  render() {
    if (BRANDING === "iqops" || branding === "iqops") {
      return this.renderIqops();
    }

    let imageURL =
      this.props.formImageUri != null
        ? "https://iqops-qa.iqkitchen.biz/" + this.props.formImageUri
        : "https://via.placeholder.com/400";
    let background = this.props.isSelected ? colors.primary : colors.formItem;
    return (
      <TouchableOpacity
        style={[styles.whiteSection, { backgroundColor: background }]}
        onPress={this.props.action}
        key={this.props.index}
      >
        <View style={{ flex: 4, marginTop: 10, marginBottom: 10 }}>
          <Text
            style={{
              fontFamily: "Roboto-Bold",
              fontSize: 20,
              margin: 5,
              paddingLeft: 10,
              color: this.props.isSelected ? "white" : colors.formItemText,
            }}
          >
            {this.props.formTitle}
          </Text>
        </View>
        {this.props.formImageUri != null && (
          <View
            style={{
              alignItems: "center",
              flex: 1,
              flexDirection: "row",
              justifyContent: "flex-end",
              marginRight: 10,
            }}
          >
            <Image
              style={styles.formImage}
              source={{
                uri: imageURL,
              }}
            />
          </View>
        )}
      </TouchableOpacity>
    );
  }
}
export default FormCard;

FormCard.propTypes = {
  formTitle: PropTypes.string,
  formSections: PropTypes.number,
  formDescription: PropTypes.string,
  formImageUri: PropTypes.string,
  isSelected: PropTypes.bool,
  formEnabled: PropTypes.bool,
  lastUsed: PropTypes.bool,
  grouped: PropTypes.bool,
  isLastInGroup: PropTypes.bool,
  action: PropTypes.func,
};

const styles = StyleSheet.create({
  whiteSection: {
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: 8,
    //flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    
    marginLeft: 10,
    marginRight: 10,
    marginTop: 10,
    padding: 10,
    shadowColor: "black",
    shadowOpacity: 0.1,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowRadius: 2,
    elevation: 2,
  },
  formImage: {
    flex: 1,
    height: 100,
    width: 100,
    resizeMode: "contain",
  },
  iqopsCard: {
    backgroundColor: colors.iqopsCardBg,
    borderRadius: 14,
    borderWidth: 2,
    borderColor: colors.iqopsCardBorder,
    marginHorizontal: 16,
    marginTop: 10,
    paddingVertical: 16,
    paddingHorizontal: 16,
    flexDirection: "row",
    alignItems: "center",
    shadowColor: "#0b4dad",
    shadowOpacity: 0.06,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
  },
  iqopsCardLastUsed: {
    backgroundColor: colors.iqopsLastUsedBg,
    borderWidth: 0,
    borderRadius: 0,
    marginHorizontal: 0,
    marginTop: 0,
    shadowOpacity: 0,
    shadowRadius: 0,
    elevation: 0,
    borderBottomWidth: 3,
    borderBottomColor: colors.iqopsLastUsed,
  },
  iqopsCardGrouped: {
    // sits inside lastUsedGroup; no outer card chrome
  },
  iqopsCardGroupedLast: {
    borderBottomWidth: 0,
  },
  iqopsCardSelected: {
    borderColor: colors.primary,
    backgroundColor: "#F5F9FF",
  },
  iqopsCardDisabled: {
    opacity: 0.65,
  },
  iqopsTitle: {
    flex: 1,
    paddingRight: 10,
    fontFamily: "Poppins-Bold",
    fontSize: 14,
    fontWeight: "700",
    color: colors.iqopsTaskName,
    lineHeight: 20,
  },
  iqopsChevron: {
    width: 12,
    height: 22,
  },
  iqopsTitleLastUsed: {
    fontFamily: "Poppins-Bold",
    fontWeight: "700",
  },
});
